export default __webpack_public_path__ + "static/media/woman.b5d15cc5.svg";